import { render, staticRenderFns } from "./MceColorPaletteComponent.vue?vue&type=template&id=4ee0b756&"
import script from "./MceColorPaletteComponent.vue?vue&type=script&lang=js&"
export * from "./MceColorPaletteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports